import { render, staticRenderFns } from "./treadOther.vue?vue&type=template&id=ade557da&scoped=true&"
import script from "./treadOther.vue?vue&type=script&lang=js&"
export * from "./treadOther.vue?vue&type=script&lang=js&"
import style0 from "./treadOther.vue?vue&type=style&index=0&id=ade557da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade557da",
  null
  
)

export default component.exports